<div mat-dialog-content>
    <p class="red">{{message}}</p>
   </div>
   <div mat-dialog-actions>
     <button mat-button (click)="onNoClick()">Non</button>
     <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Oui</button>
   </div>